import axios from 'axios';
console.log('API Base URL:', process.env.REACT_APP_API_BASE);

export const api = axios.create({
  baseURL:
    process.env.REACT_APP_API_BASE,
  withCredentials: true,
});